import { getDb } from '../db';
import type { DiagnosticsEntry } from '../../core/types';

/**
 * Metadata only — never utterance text (NFR7). This repository is deliberately
 * dumb: the stripping happens once, in `DiagnosticsService`, where it is
 * unit-tested. If a caller ever hands text to `add`, that is the bug, and the
 * service is where it gets caught.
 *
 * Diagnostics are excluded from the export: they are derived observations, not the
 * person's data, and a backup should not carry a growing telemetry log.
 */
export const diagnosticsRepo = {
  async add(type: string, payload: Record<string, unknown>): Promise<void> {
    const db = await getDb();
    await db.put('diagnostics', {
      id: crypto.randomUUID(),
      ts: new Date().toISOString(),
      type,
      payload,
    });
  },

  async byType(type: string): Promise<DiagnosticsEntry[]> {
    const db = await getDb();
    return db.getAllFromIndex('diagnostics', 'byType', type);
  },

  /** Newest first. */
  async recent(limit: number): Promise<DiagnosticsEntry[]> {
    const db = await getDb();
    const rows: DiagnosticsEntry[] = [];
    let cursor = await db.transaction('diagnostics').store.index('byTs').openCursor(null, 'prev');
    while (cursor && rows.length < limit) {
      rows.push(cursor.value);
      cursor = await cursor.continue();
    }
    return rows;
  },

  async clear(): Promise<void> {
    const db = await getDb();
    await db.clear('diagnostics');
  },
};
